/**
 * 目标站点选择器组件
 */

import React from 'react';
import { Card, Space, Select, Button, Row, Col, Tag, Typography } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { AMAZON_SITES } from '../../types';

const { Text } = Typography;

interface SiteSelectorCardProps {
    targetSites: string[];
    onSitesChange: (sites: string[]) => void;
    keywordsBySite?: Record<string, string>;
}

export const SiteSelectorCard: React.FC<SiteSelectorCardProps> = ({
    targetSites,
    onSitesChange,
    keywordsBySite = {},
}) => {
    return (
        <Card
            title={
                <Space>
                    <GlobalOutlined />
                    选择目标站点
                </Space>
            }
            bordered={false}
            style={{ marginTop: 16 }}
        >
            <Row gutter={16} align="middle">
                <Col flex="auto">
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="选择要生成文案的站点"
                        value={targetSites}
                        onChange={onSitesChange}
                        options={AMAZON_SITES.map(site => ({
                            value: site.code,
                            label: (
                                <Space>
                                    <Tag>{site.code}</Tag>
                                    {site.name}
                                    {keywordsBySite[site.code] && (
                                        <Text type="success" style={{ fontSize: 12 }}>
                                            (已配置关键词)
                                        </Text>
                                    )}
                                </Space>
                            ),
                        }))}
                    />
                </Col>
                <Col>
                    <Space>
                        <Button
                            size="small"
                            onClick={() => onSitesChange(['US'])}
                        >
                            仅美国站
                        </Button>
                        <Button
                            size="small"
                            onClick={() => onSitesChange(AMAZON_SITES.map(s => s.code))}
                        >
                            全部站点
                        </Button>
                    </Space>
                </Col>
            </Row>
            <div style={{ marginTop: 8 }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    💡 系统会根据各站点配置的关键词自动生成本地化文案
                </Text>
            </div>
        </Card>
    );
};

export default SiteSelectorCard;
